'use strict';

wbApp.controller('ContentCtrl', ['$scope', '$timeout', 'urlUtils', 'tenantSettingSvc',
function ($scope, $timeout, urlUtils, tenantSettingSvc) {

    $scope.contentType = Number(urlUtils.getQueryParams()['contentType']) || 0;

    $scope.tabs = [
    {
        title: 'TXT_LBL_TERMS_AND_CONDITIONS',
        template: 'content/content-tab.html'
    }];

    switch ($scope.contentType) 
    {
        case 0: // TermsAndConditions
            $scope.tabs[0].title = 'TXT_LBL_TERMS_AND_CONDITIONS';
            break;
        case 1: // Instructions
            $scope.tabs[0].title = 'TXT_LBL_INSTRUCTIONS';
            break;
        case 2: // TradeTerms
            $scope.tabs[0].title = 'TXT_LBL_TRADE_TERMS';
            break;
        case 3: // ProtectionOfPersonalData
            $scope.tabs[0].title = 'TXT_LBL_PROTECTION_OF_PERSONAL_DATA';
            break;
        case 4: // Custome
            $scope.tabs[0].title = tenantSettingSvc.settings.customContentTypeText;
            break;
    }


    $scope.tabs.activeTab = 0;
}]);